const obj=v=>v!==null&&typeof v==='object'&&!Array.isArray(v);
const integer=v=>Number.isSafeInteger(v)&&v>0;
const states=['not_saved','save_pending','uncertain','paused','exhausted','available'];
const boolFields=['provider_key_configured','pilot_configured','wallet_verified','guard_binding_recorded'];
const offFields=['can_request_quote','quote_requested','signing_enabled','execution_enabled','fee_collection_enabled'];
const fields=['phase','chain_id','mee_version',...boolFields,'budget_state','budget_daily_limit_cents','checked_at','expires_at','provider',
  'version_support','account_verification','commitment_verification','economic_verification',...offFields];
export const validQuoteReadiness=(v,now=Date.now())=>{
  if(!obj(v)||Object.keys(v).length!==fields.length||fields.some(k=>!Object.hasOwn(v,k))
    ||v.phase!=='prerequisites_blocked'||v.chain_id!==137||v.mee_version!=='2.2.3'
    ||boolFields.some(k=>typeof v[k]!=='boolean')||offFields.some(k=>v[k]!==false)
    ||v.version_support!=='unconfirmed'||v.account_verification!=='not_connected'
    ||v.commitment_verification!=='specification_pending'||v.economic_verification!=='not_connected'
    ||typeof v.budget_state!=='string'||!states.includes(v.budget_state)
    ||!Number.isSafeInteger(v.budget_daily_limit_cents)||v.budget_daily_limit_cents<0||v.budget_daily_limit_cents>500
    ||!integer(v.checked_at)||!integer(v.expires_at)||v.checked_at*1000>now+2000
    ||v.expires_at<=v.checked_at||v.expires_at>v.checked_at+60)return false;
  if(v.provider!==null){
    const p=v.provider,keys=['polygon_listed','usdc_listed','checked_at','expires_at','scope'];
    if(!obj(p)||Object.keys(p).length!==keys.length||keys.some(k=>!Object.hasOwn(p,k))
      ||typeof p.polygon_listed!=='boolean'||typeof p.usdc_listed!=='boolean'||(p.usdc_listed&&!p.polygon_listed)
      ||p.scope!=='provider_metadata_only'||!integer(p.checked_at)||p.checked_at*1000>now+2000
      ||!integer(p.expires_at)||p.expires_at!==p.checked_at+60||v.expires_at>p.expires_at)return false;
  }
  return true;
};